/**
 * Global configuration script for Shopify theme
 * Replaces inline scripts to comply with CSP and improve caching
 */
(function() {
  'use strict';

  // Backend/Frontend domain configuration
  const isProd = location.host === 'nex-vibe.com';
  const isLocal = location.host === '127.0.0.1:9292';
  
  window.BACKEND_DOMAIN = isLocal
    ? 'http://localhost:8088'
    : isProd
    ? 'https://api.nex-vibe.com'
    : 'https://api.nex-vibe.com';
    
  window.FRONTEND_DOMAIN = isProd 
    ? 'https://cd1ef9-4.myshopify.com' 
    : 'https://cd1ef9-4.myshopify.com';

  // Shopify routes (will be populated by Liquid)
  window.shopUrl = window.shopUrl || '';
  window.routes = window.routes || {};
  window.cartStrings = window.cartStrings || {};
  window.variantStrings = window.variantStrings || {};
  window.accessibilityStrings = window.accessibilityStrings || {};

  // Remove no-js class
  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
  
  // Add design mode class if in Shopify editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }
})();

